import {
	api
} from "./service.js";

// const apiUrl = 'http://106.53.213.190:8081/index.php/api/'
const apiUrl = 'http://openadc.com.cn:8081/index.php/api/'

const news = {
	getList(data) {
		const caseSensitive = data && (data.case_sensitive || data.caseSensitive) ? 1 : 0
		return api.get(apiUrl + "datalist/getList?model=" +
			data.model + '&page=' + data.page + "&per_page=" + data.per_page + "&case_sensitive=" + caseSensitive)
	},
	// 获取 fkhx_datalist 总记录数
	getDatalistTotal() {
		return api.get(apiUrl + "datalist/getTotal")
	},
	getDetail(data) {
		return api.get(apiUrl + "datalist/getInfo?id=" + data)
		// return api.post("api/news/editNewsDetail", data);
	},
	getMember() {
		return api.get(apiUrl + "member/getlist")
	},
	getMilestone() {
		return api.get(apiUrl + "milestone/getlist")
	},
	getPaper(data) {
		return api.get(apiUrl + "paper/getlist?page=" + data)
	},
	getConfig() {
		return api.get(apiUrl + "index/getConfig")
	},
	getNews(data) {
		return api.get(apiUrl + "news/getList?page=" + data)
	}

}
export default news;